@if (isLoading) {
  <div class="loading">
    <app-loading></app-loading>
  </div>
}

@if (!isLoading) {
  <div>
    @if (isTribeSelected && !isSelf) {
      <div class="user-gifts-header">
        <button mat-raised-button [appThemedButton]="theme" (click)="sendGift()">
          <span class="material-icons">card_giftcard</span>
          ส่งของขวัญ
        </button>
      </div>
    }
    @if (userGifts.length > 0) {
      <div class="user-gifts">
        @for (gift of userGifts; track gift) {
          <app-gift class="gift" [gift]="gift" [theme]="theme" mode="profile"></app-gift>
        }
      </div>
    }
    @if (userGifts.length <= 0) {
      <div class="gifts-status">This user does not have any gift.</div>
    }
  </div>
}
